// src/features/dashboard/components/OverviewCard.tsx

import {
  useOverviewCard,
} from '../hooks/Employee/useOverviewCard';

const OverviewCard = () => {

  const {
    data,
    loading,
  } = useOverviewCard();

  if (
    loading ||
    !data
  ) {
    return null;
  }

  return (
    <div
      className="
        rounded-[14px]
        border
        border-[#D0D5DD]
        bg-white
        px-[16px]
        py-[14px]
      "
    >
      <h2
        className="
          mb-[16px]
          text-[12px]
          font-semibold
          text-[#002B5B]
        "
      >
        Summary
      </h2>

      {data.items.map(
        (
          item,
          index,
        ) => (
          <div
            key={item.title}
          >
            <div
              className="
                mb-[7px]
                flex
                items-center
                justify-between
              "
            >
              <p
                className="
                  text-[10px]
                  tracking-[1px]
                  text-[#344054]
                "
              >
                {item.title}
              </p>

              <p
                className="
                  text-[10px]
                  font-medium
                  text-[#101828]
                "
              >
                {item.percent}
              </p>
            </div>

            <div
              className="
                h-[8px]
                overflow-hidden
                rounded-full
                bg-[#E4E7EC]
              "
            >
              <div
                className={`
                  h-full
                  rounded-full
                  ${item.color}
                `}
                style={{
                  width:
                    item.width,
                }}
              />
            </div>

            <div
              className="
                mt-[8px]
                flex
                items-center
                gap-[4px]
              "
            >
              <span
                className="
                  text-[14px]
                  font-semibold
                  text-[#101828]
                "
              >
                {item.value}
              </span>

              <span
                className="
                  text-[10px]
                  text-[#667085]
                "
              >
                {item.target}
              </span>
            </div>

            {index !==
              data.items.length - 1 && (
              <div
                className="
                  my-[14px]
                  border-t
                  border-dashed
                  border-[#D0D5DD]
                "
              />
            )}
          </div>
        ),
      )}
    </div>
  );
};

export default OverviewCard;